import { App } from "vue";
import { type CategoryFilter, useCategoryFilter } from "@/composables/filters/category-filter";
import { type ProductFilter, useProductFilter } from "@/composables/filters/product-filter";

export const categoryFilterSymbol = Symbol( 'category-filter' );
export const productFilterSymbol = Symbol( 'product-filter' );

// The paging filter and the article/webinar/trade-alert/bonus-report filters are no longer provided app-wide: they
// were bound to one set of search text, dates and page shared by every list (rank 31). Each list root now calls
// provideListFilterScope() and its own use*Filters(), and a control reaches the list's page through usePagingFilter().
const ContentFiltersPlugin = {
    install( app: App< Element > ) {
        // Register the Category Filter provider
        app.provide< CategoryFilter >( categoryFilterSymbol, useCategoryFilter() );
        // Register the Product Filter provider
        app.provide< ProductFilter >( productFilterSymbol, useProductFilter() );
    }
}

export default ContentFiltersPlugin;
